import { findIndex } from "@dhx/ts-common/core";
import { Grid } from "./Grid";
import { GridEvents } from "./types";
import { getScrollbarWidth } from "../../ts-common/html";

export function startResize(grid: Grid, column: string, ev: MouseEvent & TouchEvent, cb: any) {
	ev.targetTouches && ev.preventDefault();
	const initX = ev.targetTouches ? ev.targetTouches[0].clientX : ev.clientX;
	const columns = grid.config.columns.filter(col => !col.hidden);
	let initWidth = 0;
	grid.config.$resizing = column;

	const moveHandler = e => {
		const i = findIndex(columns, obj => {
			return obj.id === column;
		});

		const currentX = e.targetTouches ? e.targetTouches[0].clientX : e.clientX;
		const containerLeft = currentX - grid.getRootNode().getBoundingClientRect().left;
		const scrollbarY = grid.config.$totalHeight > grid.config.height ? getScrollbarWidth() : 0;

		if (grid.config.leftSplit === i + 1 && containerLeft >= grid.config.width - scrollbarY - 2) {
			return;
		}

		initWidth = initWidth || columns[i].$width;
		const minWidth = columns[i].minWidth || 40;
		const maxWidth = columns[i].maxWidth;
		const move = currentX - initX;
		const cols = [...columns];
		const size = initWidth + move;
		let final;
		if ((maxWidth && size >= maxWidth) || size <= minWidth) {
			if (size <= minWidth) {
				final = minWidth;
			}
			if (size >= maxWidth) {
				final = maxWidth;
			}
		} else {
			final = size;
		}
		cols[i].$width = final;
		cols[i].$fixed = true;
		grid.events.fire(GridEvents.resize, [columns[i], e]);
		grid.paint();
	};

	const upHandler = () => {
		if (!ev.targetTouches) {
			document.removeEventListener("mousemove", moveHandler);
			document.removeEventListener("mouseup", upHandler);
		} else {
			document.removeEventListener("touchmove", moveHandler);
			document.removeEventListener("touchend", upHandler);
		}
		cb();
	};

	if (!ev.targetTouches) {
		document.addEventListener("mousemove", moveHandler);
		document.addEventListener("mouseup", upHandler);
	} else {
		document.addEventListener("touchmove", moveHandler);
		document.addEventListener("touchend", upHandler);
	}
	grid.paint();
}
